import {create} from 'zustand';

type StepState = {
	currentStep: number;
	setStep: (step: number) => void;
	nextStep: () => void;
	reset: () => void;
};

export const useCurrentStepStore = create<StepState>(set => ({
	currentStep: 0,

	setStep: step => set({currentStep: step}),

	nextStep: () =>
		set(state => ({
			currentStep: state.currentStep + 1,
		})),

	reset: () => set({currentStep: 0}),
}));
